import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AccountService } from './account.service';

import { environment } from '../http/environment';
import { ReCaptchaV3Service } from 'ngx-captcha';

@Component({
   selector: 'app-account',
   templateUrl: './account.component.html',
   styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

   constructor(
      public router: Router,
      public accountService: AccountService,
      private recaptcha: ReCaptchaV3Service,
   ) { }

   ngOnInit() {
      sessionStorage.removeItem( 'accountInfo' );
   }

   check() {
      if ( !environment.production ) { return this.continue(); }

      this.recaptcha.execute( '6LchSnAUAAAAAMAHgohw2X1xgDNIEEqzf4p9gQBE', 'paymentAccount', token => {
         if ( !token ) {
            this.accountService.error = 'ReCaptcha Failed';

            return false;
         }

         this.continue();
      });
   }

   continue() {
      this.accountService.verifyAccount().subscribe( _ =>
            this.router.navigate([ 'pay' ]));
   }
}
